import { render, staticRenderFns } from "./MtipoequipamientoModals.vue?vue&type=template&id=2fb58f2e"
import script from "./MtipoequipamientoModals.vue?vue&type=script&lang=js"
export * from "./MtipoequipamientoModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports